"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnderlineOffset = exports.getButtonBorderColor = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const getButtonBorderColor = props => {
  if (props.appearance === "secondary-outlined") {
    return `${(0, _designTokensReact.color)("color--border--neutral--weak")}`;
  } else {
    // Since some buttons use a border, we'll add a transparent border to all buttons by
    // default. This helps our focus ring code to have a consistent target radius.
    return `transparent`;
  }
};
exports.getButtonBorderColor = getButtonBorderColor;
const underlineOffset = (0, _sdsThemeInternal.themed)({
  "lodestar-light": "1px",
  "ursa-light": "2px"
});
const getUnderlineOffset = _ref => {
  let {
    themeMode
  } = _ref;
  return underlineOffset(themeMode);
};
exports.getUnderlineOffset = getUnderlineOffset;
//# sourceMappingURL=getButtonBorder.js.map